module.exports = __webpack_public_path__ + "static/media/racquetball.ca476b8c.svg";